import React from 'react';

const HighlightText = (props) => {
  const { text, highlight, style } = props;

  const splitRegex = new RegExp(highlight, 'i');
  const wordMatch = text.match(splitRegex);

  if (wordMatch === null) {
    return <React.Fragment>{text}</React.Fragment>;
  } else {

    const stringArray = text.split(wordMatch[0]);

    const wrappedArray = stringArray.reduce((wrappedArray, str, index) => {
      wrappedArray.push(str);
      if (index < stringArray.length - 1) {
        wrappedArray.push(<span style={style}>{wordMatch[0]}</span>)
      }
      return wrappedArray;
    }, []);

    return (
      <React.Fragment>
        {wrappedArray.map((str, i) => (
          <React.Fragment key={i}>{str}</React.Fragment>
        ))}
      </React.Fragment>
    );

  }

};

export default HighlightText;
